module.exports = __webpack_public_path__ + "static/media/girl-profile.85bfb77a.png";